import {
  FormikNumberField,
  FormikTextField,
  SuspendedFormikPhoneField,
} from '@superdispatch/forms';
import { Stack } from '@superdispatch/ui';
import { Alert, TextBox } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { WarningIcon } from 'shared/icons/WarningIcon';

export function DriverFormFields({
  hasWarning,
  type,
}: {
  hasWarning: boolean;
  type: 'add' | 'edit' | 'invite';
}) {
  const disabled = type === 'edit' && !isWebView;
  return (
    <Stack space="small">
      {hasWarning && (
        <Alert severity="caution" icon={<WarningIcon />}>
          This driver has both dispatcher and driver roles. Profile information
          for both roles will be updated.
        </Alert>
      )}

      {(type === 'add' || type === 'invite') && (
        <TextBox color="secondary" variant="body">
          Information entered will be used to send the driver text message and
          email with instructions to download the Super Dispatch Driver App.
        </TextBox>
      )}

      {type !== 'invite' && (
        <FormikTextField fullWidth={true} name="name" label="Full Name" />
      )}
      <FormikTextField
        fullWidth={true}
        type="email"
        name="email"
        label="Email"
        disabled={disabled}
      />
      <SuspendedFormikPhoneField
        fullWidth={true}
        name={type === 'invite' ? 'phone_number' : 'phone'}
        label="Phone"
        disabled={disabled}
      />
      {type !== 'invite' && (
        <FormikNumberField
          fullWidth={true}
          name="trailer.capacity"
          label="Trailer Capacity"
          disabled={disabled}
        />
      )}
    </Stack>
  );
}
